import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Skeleton, TableCell, TableRow, Tooltip } from "@mui/material";
import { GroupBlueIcon, ScheduleOrangeIcon, ViewerGreyIcon } from "../../icons";
import { DeleteGroupDialog } from "./id/DeleteGroup";
import { TypographyNormal, TypographySmall } from "../customComponent";
import { colorStyling } from "../../helpers/color";
import { SET_DETAIL_GROUP } from "../../store/actionTypes/groupActionType";
import { parseVariables } from "../../helpers/localize";
import ViewerListDialog from "./ViewerListDialog";
import ScheduleListDialog from "./ScheduleListDialog";

const PREFIX = "GroupItem";

const classes = {
  hover: `${PREFIX}-hover`,
};

const GroupItem = ({ group, dispatch, index }) => {
  const navigate = useNavigate();

  const { t } = useTranslation("group");

  const [openViewerList, setOpenViewerList] = useState(false);
  const [openScheduleList, setOpenScheduleList] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleCloseViewerList = (e) => {
    e.stopPropagation();
    setOpenViewerList(false);
  };

  const handleCloseScheduleList = (e) => {
    e.stopPropagation();
    setOpenScheduleList(false);
  };

  const handleCloseDeleteDialog = (e) => {
    e.stopPropagation();
    setOpenDeleteDialog(false);
  };

  const redirectToGroupDetailPage = (id) => {
    dispatch({ type: SET_DETAIL_GROUP, payload: group });
    navigate("/group/detail/" + id);
  };

  return (
    <TableRow
      key={group.name + group.id}
      onClick={() => redirectToGroupDetailPage(group.id)}
      sx={{
        cursor: "pointer",
        backgroundColor:
          (index + 1) % 2 !== 0
            ? colorStyling.white.hover
            : colorStyling.white.full,
        "&:hover": {
          backgroundColor: colorStyling.white.lightblue,
        },
      }}
    >
      <TableCell align="left">
        <Box
          sx={{
            ml: 2,
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <ViewerListDialog
            group={group}
            open={openViewerList}
            handleClose={handleCloseViewerList}
          />
          <ScheduleListDialog
            group={group}
            open={openScheduleList}
            handleClose={handleCloseScheduleList}
          />
          <DeleteGroupDialog
            group={group}
            open={openDeleteDialog}
            handleClose={handleCloseDeleteDialog}
            doNavigate={false}
          />

          <GroupBlueIcon />
          <Box ml={2}>
            <Tooltip
              title={group?.name?.length > 30 ? group.name : ""}
              placement="top-start"
            >
              <Box>
                <TypographyNormal
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      textDecoration: "underline",
                      color: colorStyling.primary,
                    },
                  }}
                >
                  {group?.name?.length > 30
                    ? group.name.substring(0, 27).trim() + "..."
                    : group.name}
                </TypographyNormal>
              </Box>
            </Tooltip>
          </Box>
        </Box>
      </TableCell>

      <TableCell align="left">
        <Box
          display="flex"
          alignItems="center"
          className={classes.hover}
          onClick={(e) => {
            e.stopPropagation();
            setOpenViewerList(true);
          }}
        >
          <ViewerGreyIcon />
          {group.screensCount || group.screensCount === 0 ? (
            <TypographySmall
              className="text"
              sx={{
                ml: "5px",
                fontWeight: 500,
                textDecoration: "underline",
              }}
            >
              {parseVariables(t("item.numViewers"), {
                num: group.screensCount ?? 0,
              })}
            </TypographySmall>
          ) : (
            <Skeleton
              variant="text"
              sx={{
                fontSize: "12px",
                lineHeight: "24px",
                width: "80px",
              }}
            />
          )}
        </Box>
      </TableCell>

      <TableCell align="left">
        <Box
          display="flex"
          alignItems="center"
          className={classes.hover}
          onClick={(e) => {
            e.stopPropagation();
            setOpenScheduleList(true);
          }}
        >
          <ScheduleOrangeIcon />

          {group.schedulesCount || group.schedulesCount === 0 ? (
            <TypographySmall
              className="text"
              sx={{
                ml: "5px",
                fontWeight: 500,
                textDecoration: "underline",
              }}
            >
              {parseVariables(t("item.numSchedules"), {
                num: group.schedulesCount ?? 0,
              })}
            </TypographySmall>
          ) : (
            <Skeleton
              variant="text"
              sx={{
                fontSize: "12px",
                lineHeight: "24px",
                width: "80px",
              }}
            />
          )}
        </Box>
        {/* Temporary Disabled */}
        {/* <Box>
            <IconButton
              sx={{ color: colorStyling.black }}
              onClick={(e) => {
                e.stopPropagation();
                handleClickMenu(e);
              }}
            >
              <MoreVertIcon />
            </IconButton>

            <Menu
              id="basic-menu"
              anchorEl={anchorMenu}
              open={openMenu}
              onClose={(e) => {
                e.stopPropagation();
                handleCloseMenu();
              }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  redirectToGroupDetailPage(group.id);
                  handleCloseMenu();
                }}
                dense
              >
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{ marginRight: "5px" }}
                />
                {t("item.menuDetailsBtn")}
              </MenuItem>
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDeleteDialog(true);
                  handleCloseMenu();
                }}
                dense
                sx={{ color: red[600] }}
              >
                <DeleteOutlinedIcon fontSize="small" sx={{ mr: "5px" }} />
                {t("item.menuDeleteBtn")}
              </MenuItem>
            </Menu>
          </Box> */}
      </TableCell>
    </TableRow>
  );
};

export default GroupItem;
